const SRCSET_SIZES = [200, 320, 400, 640, 800, 960];

/**
 * Returns a single url with passed fastly options as query params.
 *
 * @export
 * @param {string} url - url of the image
 * @param {number} width - desired image width
 * @param {number} [quality=60] - image quality
 * @returns {string}
 */
function getSrcSetUrl(url, width, quality = 60) {
    return `${url}?disable=upscale&auto=webp&srcset=disallow&quality=${quality}&width=${width}`;
}

/**
 * Builds a src set string to be used accross this app.
 *
 * @export
 * @param {string} url - url of the image
 * @returns {string}
 */
export function getSrcSetString(url, options = {}) {
    const { widths, quality } = options;
    return (widths || SRCSET_SIZES)
        .map(width => `${getSrcSetUrl(url, width, quality)} ${width}w`)
        .join(', ');
}
